import { render, staticRenderFns } from "./AdminApplyDialog.vue?vue&type=template&id=f81bd0e4&scoped=true"
import script from "./AdminApplyDialog.vue?vue&type=script&lang=js"
export * from "./AdminApplyDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminApplyDialog.vue?vue&type=style&index=0&id=f81bd0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81bd0e4",
  null
  
)

export default component.exports